import { useEffect } from "react";
import { useAPIGetDashboardKabagTransport } from "../api/api-get-dashboard-kabag-transport";
import CardBerangkatPulang from "./card-berangkat-pulang";
import { FaCarSide } from "react-icons/fa";
import { FaTruck, FaTruckPickup } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import TabelService from "./tabel-service";
import TabelProblem from "./tabel-problem";

const title = "Dashboard Transport";

const DashboardKabagTransport = () => {
  const { dataDashboard: data, fetchData } = useAPIGetDashboardKabagTransport();
  const dispatch = useDispatch();

  // use effect section
  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));

    fetchData();
  }, []);

  return (
    <div className="col-start-start w-full p-4 gap-4">
      <div className="flex flex-col min-[885px]:flex-row justify-start items-start w-full gap-4">
        <CardBerangkatPulang
          bgColorTw="bg-gray-300"
          borderColorTw="border-gray-300"
          textColorTw="text-gray-600"
          icon={<FaCarSide className="text-gray-600" />}
          judul="Mobil Kecil"
          jumlahBerangkat={data.data_mobil?.sedang_berjalan}
          jumlahPulang={data.data_mobil?.sudah_pulang}
        />
        <CardBerangkatPulang
          bgColorTw="bg-emerald-300"
          borderColorTw="border-emerald-300"
          textColorTw="text-emerald-500"
          icon={<FaTruck className="text-emerald-600" />}
          judul="Dutro"
          jumlahBerangkat={data.data_dutro?.sedang_berjalan}
          jumlahPulang={data.data_dutro?.sudah_pulang}
        />
        <CardBerangkatPulang
          bgColorTw="bg-rose-300"
          borderColorTw="border-rose-300"
          textColorTw="text-rose-500"
          icon={<FaTruckPickup className="text-rose-600" />}
          judul="Trado"
          jumlahBerangkat={data.data_trado?.sedang_berjalan}
          jumlahPulang={data.data_trado?.sudah_pulang}
        />
      </div>
      <div className="flex flex-col sm:flex-col justify-start items-start w-full gap-4">
        <TabelService judul="" data={data.data_warning_services} />
        {/* <TabelProblem judul="Notif Problem Mobil" data={data.data_problems} /> */}
      </div>
    </div>
  );
};

export default DashboardKabagTransport;
